(function() {
  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function scoreItem(item, query) {
    const title = normalize(item.dataset.title);
    const context = normalize(item.dataset.context);
    const keywords = normalize(item.dataset.keywords);
    const haystack = [title, context, keywords].join(' ');
    const tokens = query.split(' ').filter(Boolean);

    function matchesToken(token) {
      if (haystack.includes(token)) return true;
      if (token.endsWith('ies') && token.length > 4 && haystack.includes(token.slice(0, -3) + 'y')) return true;
      if (token.endsWith('s') && token.length > 3 && haystack.includes(token.slice(0, -1))) return true;
      return false;
    }

    if (!tokens.length || !tokens.every(matchesToken)) return -1;

    let score = 0;
    if (title === query) score += 100;
    if (title.startsWith(query)) score += 60;
    if (title.includes(query)) score += 40;
    if (keywords.includes(query)) score += 24;
    if (context.includes(query)) score += 12;

    tokens.forEach(function(token) {
      if (title.includes(token)) score += 8;
      if (keywords.includes(token)) score += 4;
      if (context.includes(token)) score += 2;
    });

    return score;
  }

  function getHeaderOffset() {
    const header = document.querySelector('.section-header, sticky-header, header');
    return header ? Math.min(header.getBoundingClientRect().height, 180) + 20 : 24;
  }

  function findByText(elements, label) {
    const normalizedLabel = normalize(label);
    return Array.from(elements).find(function(element) {
      return normalize(element.textContent) === normalizedLabel;
    });
  }

  function revealDestination(item) {
    const sectionId = item.dataset.targetSection;
    const targetType = item.dataset.targetType || 'section';
    const targetLabel = item.dataset.targetLabel;
    const sectionRoot = document.getElementById('shopify-section-' + sectionId) ||
      Array.from(document.querySelectorAll('.shopify-section[id]')).find(function(section) {
        return section.id.endsWith('__' + sectionId);
      });
    if (!sectionRoot) return false;

    let scrollTarget = sectionRoot;
    let focusTarget = sectionRoot.querySelector('h1, h2, h3');
    let highlightTarget = focusTarget || sectionRoot;

    if (targetType === 'dropdown') {
      const details = Array.from(sectionRoot.querySelectorAll('[data-bsg-flexible-dropdown-item]')).find(function(detail) {
        const heading = detail.querySelector('.bsg-flexible-dropdown__summary-heading');
        return heading && normalize(heading.textContent) === normalize(targetLabel);
      });

      if (details) {
        details.open = true;
        scrollTarget = details;
        focusTarget = details.querySelector('summary');
        highlightTarget = focusTarget || details;
      }
    }

    if (targetType === 'tab') {
      const tab = findByText(sectionRoot.querySelectorAll('[data-bsg-flexible-tab]'), targetLabel);
      if (tab) {
        tab.click();
        scrollTarget = tab;
        focusTarget = tab;
        const panelId = tab.getAttribute('aria-controls');
        highlightTarget = document.getElementById(panelId) || tab;
      }
    }

    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(function() {
        const top = scrollTarget.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({
          top: Math.max(0, top),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });

        if (focusTarget) {
          if (!focusTarget.matches('button, summary, a, input, [tabindex]')) {
            focusTarget.setAttribute('tabindex', '-1');
          }
          focusTarget.focus({ preventScroll: true });
        }

        highlightTarget.classList.remove('bsg-guide-search-target-highlight');
        void highlightTarget.offsetWidth;
        highlightTarget.classList.add('bsg-guide-search-target-highlight');
        window.setTimeout(function() {
          highlightTarget.classList.remove('bsg-guide-search-target-highlight');
        }, 2200);
      });
    });

    return true;
  }

  let floatingNavObserver = null;

  function releaseChatState() {
    document.body.classList.remove('bsg-guide-search-chat-open');
    if (floatingNavObserver) {
      floatingNavObserver.disconnect();
      floatingNavObserver = null;
    }
  }

  function suppressFloatingNavigation() {
    document.body.classList.add('bsg-guide-search-chat-open');
    document.body.classList.remove('bsg-flexible-columns-2-floating-nav-visible');

    if (!floatingNavObserver && 'MutationObserver' in window) {
      floatingNavObserver = new MutationObserver(function() {
        if (document.body.classList.contains('bsg-guide-search-chat-open')) {
          document.body.classList.remove('bsg-flexible-columns-2-floating-nav-visible');
        }
      });
      floatingNavObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function openTidioChat() {
    function openChat() {
      if (!window.tidioChatApi) return false;
      suppressFloatingNavigation();
      if (typeof window.tidioChatApi.show === 'function') window.tidioChatApi.show();
      if (typeof window.tidioChatApi.open === 'function') window.tidioChatApi.open();
      if (typeof window.tidioChatApi.on === 'function' && !document.body.dataset.bsgGuideSearchChatCloseBound) {
        document.body.dataset.bsgGuideSearchChatCloseBound = 'true';
        window.tidioChatApi.on('close', releaseChatState);
      }
      return true;
    }

    if (!openChat()) {
      document.addEventListener('tidioChat-ready', openChat, { once: true });
    }
  }

  function initGuideSearch(root) {
    if (!root || root.dataset.bsgGuideSearchInitialized === 'true') return;
    root.dataset.bsgGuideSearchInitialized = 'true';

    const input = root.querySelector('[data-bsg-guide-search-input]');
    const field = root.querySelector('.bsg-guide-search__field');
    const clearButton = root.querySelector('[data-bsg-guide-search-clear]');
    const results = root.querySelector('[data-bsg-guide-search-results]');
    const resultsLabel = root.querySelector('[data-bsg-guide-search-results-label]');
    const empty = root.querySelector('[data-bsg-guide-search-empty]');
    const status = root.querySelector('[data-bsg-guide-search-status]');
    const config = root.querySelector('[data-bsg-guide-search-config]');
    const items = Array.from(root.querySelectorAll('[data-bsg-guide-search-item]'));
    if (!input || !results || !items.length || !config) return;

    const maxResults = parseInt(config.dataset.maxResults, 10) || 8;

    function visibleButtons() {
      return items.filter(function(item) { return !item.hidden; }).map(function(item) {
        return item.querySelector('[data-bsg-guide-search-result]');
      }).filter(Boolean);
    }

    function closeResults(options) {
      if (results.hidden) return;

      const preserveScrollPosition = options && options.preserveScrollPosition;
      let removedHeight = 0;
      let scrollPosition = 0;

      if (preserveScrollPosition) {
        const resultStyles = window.getComputedStyle(results);
        removedHeight = results.getBoundingClientRect().height +
          parseFloat(resultStyles.marginTop || 0) +
          parseFloat(resultStyles.marginBottom || 0);
        scrollPosition = window.scrollY;
      }

      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');

      if (preserveScrollPosition && removedHeight > 0) {
        window.scrollTo({
          top: Math.max(0, scrollPosition - removedHeight),
          behavior: 'auto'
        });
      }
    }

    function showResults() {
      const query = normalize(input.value);
      let matches = [];

      if (query) {
        matches = items.map(function(item, index) {
          return { item: item, score: scoreItem(item, query), index: index };
        }).filter(function(match) {
          return match.score >= 0;
        }).sort(function(a, b) {
          return b.score - a.score || a.index - b.index;
        }).slice(0, maxResults).map(function(match) {
          return match.item;
        });
      } else {
        matches = items.filter(function(item) {
          return item.dataset.suggested === 'true';
        }).slice(0, maxResults);
      }

      items.forEach(function(item) {
        item.hidden = !matches.includes(item);
      });

      const hasMatches = matches.length > 0;
      empty.hidden = !query || hasMatches;
      resultsLabel.hidden = !hasMatches;
      resultsLabel.textContent = query ? config.dataset.resultsLabel : config.dataset.suggestionsLabel;
      status.textContent = query ? (hasMatches ? matches.length + ' guide results found.' : 'No guide results found.') : '';
      clearButton.hidden = !input.value;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('focus', function() {
      releaseChatState();
      showResults();
    });
    input.addEventListener('click', function() {
      releaseChatState();
      if (results.hidden) showResults();
    });
    input.addEventListener('input', showResults);
    input.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeResults();
        input.blur();
        return;
      }

      if (event.key === 'ArrowDown') {
        const firstResult = visibleButtons()[0];
        if (firstResult) {
          event.preventDefault();
          firstResult.focus();
        }
      }

      if (event.key === 'Enter') {
        const firstResult = visibleButtons()[0];
        if (firstResult) {
          event.preventDefault();
          firstResult.click();
        }
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', function() {
        input.value = '';
        clearButton.hidden = true;
        input.focus({ preventScroll: true });
        closeResults();
      });
    }

    items.forEach(function(item) {
      const button = item.querySelector('[data-bsg-guide-search-result]');
      if (!button) return;

      button.addEventListener('click', function() {
        if (revealDestination(item)) closeResults();
      });

      button.addEventListener('keydown', function(event) {
        const buttons = visibleButtons();
        const index = buttons.indexOf(button);
        if (event.key === 'ArrowDown' && buttons[index + 1]) {
          event.preventDefault();
          buttons[index + 1].focus();
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (buttons[index - 1]) buttons[index - 1].focus();
          else input.focus();
        }
        if (event.key === 'Escape') {
          closeResults();
          input.focus();
        }
      });
    });

    root.querySelectorAll('[data-bsg-guide-search-chat]').forEach(function(button) {
      button.addEventListener('click', openTidioChat);
    });

    document.addEventListener('pointerdown', function(event) {
      const clickedField = field && field.contains(event.target);
      const clickedResults = results.contains(event.target);
      if (!clickedField && !clickedResults) closeResults();
    }, { passive: true });

    window.addEventListener('scroll', function() {
      if (results.hidden) return;

      const rootBounds = root.getBoundingClientRect();
      if (rootBounds.bottom < getHeaderOffset() || rootBounds.top > window.innerHeight) {
        closeResults({ preserveScrollPosition: true });
      }
    }, { passive: true });
  }

  function initAllGuideSearches(scope) {
    const searchScope = scope || document;
    if (searchScope.matches && searchScope.matches('[data-bsg-guide-search]')) {
      initGuideSearch(searchScope);
    }
    searchScope.querySelectorAll('[data-bsg-guide-search]').forEach(initGuideSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllGuideSearches(document);
    });
  } else {
    initAllGuideSearches(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllGuideSearches(event.target);
  });
})();
